/* import __COLOCATED_TEMPLATE__ from './inserter-canvas.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();